export const setPageUrl = (page) => {
  const params = new URLSearchParams(document.location.search.substring(1));

  params.set(`p`, page);
  const url = `${window.location.origin}${window.location.pathname}?${params.toString()}`;

  window.history.pushState(null, null, url);
};
